<template>
    <modal name="DocumentJenisTransaksi" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
            role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> Jenis Transkasi </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label">Jenis Nilai</label>
                            <div class="col-sm-9">
                                <v-select :options="fetchJenis" v-model="jenisNilai" label="label"
                                    return-object></v-select>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label">Jatuh Tempo</label>
                            <div class="col-sm-9">
                                <date-picker v-model="forms.jatuhTempo" input-class="form-control"
                                    placeholder="YYYY-MM-DD" format="YYYY-MM-DD" valueType="format" type="date"
                                    required></date-picker>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <label class="col-sm-3 col-form-label">Voluntary Declaration</label>
                            <div class="col-sm-9">
                                <input type="number" v-model.number="nilaiBarangVd" class="form-control"
                                    :id="this.$dynamicId()">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">Batal</button>
                        <button type="button" class="btn btn-primary" @click.prevent="submitData()">Simpan</button>
                    </div>

                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/id';
export default {
    name: "DocumentJenisTransaksi",
    components: {
        DatePicker
    },
    data() {
        return {
            forms: {
                nilaiBarangVd: 0
            },
            fetchJenis: [],
            jenisNilai: null,
        }
    },
    methods: {
        removeModals() {
            this.selectedRow = [];
            this.$modal.hide('DocumentJenisTransaksi');
        },
        submitData() {
            this.forms.jenisNilai = this.jenisNilai
            this.$emit("closeModal", this.forms);
            this.removeModals();
            this.forms = {
                nilaiBarangVd: 0
            };
            this.jenisNilai = null;
        },
        asyncJenisVd() {

            this.fetchJenis = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=jenisVd";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {
                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchJenis.push(md);

                        }
                    }
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
    },
    computed: {
        nilaiBarangVd: {
            get: function () {
                let val = 0;
                if (this.forms?.nilaiBarangVd) {
                    val = this.forms.nilaiBarangVd.toFixed(2);
                }
                return val;
            },
            set: function (newValue) {
                this.forms.nilaiBarangVd = newValue;
            }

        },
    },
    created() {
        this.asyncJenisVd();
    },
}
</script>

<style></style>